import type { StorageAdapter } from '@urql/exchange-graphcache'
import {
  type StorageOptions,
  makeDefaultStorage,
} from '@urql/exchange-graphcache/default-storage'
import { useCreation } from 'ahooks'
import { createContext, useContext } from 'react'
import { GRAPH_CACHE_MAX_AGE } from '../../data/environment'

const dbCacheName = 'CS:crew-app-v2-graphcache'

const cacheStorageOptions: StorageOptions = {
  idbName: dbCacheName,
  maxAge: GRAPH_CACHE_MAX_AGE,
}

const GraphQLCacheContext = createContext<{
  cache: StorageAdapter
  clear: () => Promise<void>
}>({
  cache: {
    readData: () => Promise.resolve({}),
    writeData: () => Promise.resolve({}),
    readMetadata: () => Promise.resolve(null),
    writeMetadata: () => {},
    onOnline: () => {},
    onCacheHydrated: () => {},
  },
  clear: () => Promise.resolve(),
})

export const useGraphQLCache = () => useContext(GraphQLCacheContext)

export const GraphQLCacheProvider = ({ children }: React.PropsWithChildren) => {
  const value = useCreation(() => {
    const cache = makeDefaultStorage(cacheStorageOptions)
    return {
      cache,
      clear: cache.clear,
    }
  }, [])
  return (
    <GraphQLCacheContext.Provider value={value}>
      {children}
    </GraphQLCacheContext.Provider>
  )
}
